import Routes from "routing/Routes";
import "./inputTitleLinks";
const streamsOverviewBindings = {
  inputTitleLinks: [
    {
      type: "input",
      buildPath: (resolved) => Routes.SYSTEM.INPUT_DIAGNOSIS(resolved.id)
    }
  ]
};
export default streamsOverviewBindings;
